import { PropsWithChildren, Fragment } from 'react';

/**
 * These props are required for the ResizableHorizontal/Vertical children.
 * We cannot place them directly on the HTML elements as they are not valid HTML attrbutes and styled-components v6
 * requires them to prefixed with `$` as they are 'transient' props. But, as they are not for styling
 * this would be a misleading change. So we use a wrapper component instead to get around this.
 */

type HorizontalResizableContainerWrapperProps = {
  minWidth?: number;
  initialWidth?: number;
  isCollapsed?: boolean;
};

export const HorizontalResizableContainerWrapper = ({
  children,
}: PropsWithChildren<HorizontalResizableContainerWrapperProps>) => {
  return <Fragment>{children}</Fragment>;
};
